module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Hunzenschwil_COA-576bc944f84d52ba72660eacdebed958.svg";